import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { Subscription, timer } from 'rxjs';
import { UPDATE_TOAST_DURATION_SECONDS } from './update-ready-toast.constants';

@Component({
  selector: 'firebird-web-update-ready-toast',
  templateUrl: './update-ready-toast.component.html',
  styleUrls: ['./update-ready-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpdateReadyToastComponent implements OnInit, OnDestroy {
  remainingSeconds = UPDATE_TOAST_DURATION_SECONDS;

  private countdownSubscription?: Subscription;

  constructor(
    private readonly snackRef: MatSnackBarRef<UpdateReadyToastComponent>,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  get progressValue(): number {
    return (this.remainingSeconds / UPDATE_TOAST_DURATION_SECONDS) * 100;
  }

  ngOnInit(): void {
    this.countdownSubscription = timer(0, 1000).subscribe((elapsedSeconds) => {
      this.remainingSeconds = UPDATE_TOAST_DURATION_SECONDS - elapsedSeconds;
      this.changeDetectorRef.markForCheck();
      if (this.remainingSeconds <= 0) {
        this.reloadPage();
        this.snackRef.dismiss();
      }
    });
  }

  ngOnDestroy(): void {
    this.countdownSubscription?.unsubscribe();
  }

  reloadPage(): void {
    location.reload();
  }
}
